import React from "react";
import { Box, Skeleton, Grid, Card, CardHeader, CardContent, CardActions, Container } from "@mui/material";

// Skeleton component for loading state
const DivesiteSkeleton = () => (
  <Container
    maxWidth="md"
    sx={{
      my: { xs: 1, sm: 2, md: 4 },
      px: { xs: 0.5, sm: 2 },
    }}
  >
    <Card
      sx={{
        maxWidth: { xs: "100%", sm: "800px" },
        margin: "0 auto",
        background: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(20px)",
        borderRadius: { xs: 2, sm: 4 },
        boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
      }}
    >
      {/* Header Skeleton */}
      <CardHeader
        avatar={
          <Skeleton variant="circular" width={56} height={56} />
        }
        title={
          <Skeleton variant="text" width="60%" height={40} sx={{ mb: 1 }} />
        }
        subheader={
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <Skeleton variant="rounded" width={80} height={24} />
            <Skeleton variant="rounded" width={100} height={24} />
          </Box>
        }
        action={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="circular" width={32} height={32} />
          </Box>
        }
        sx={{
          background:
            "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
          borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
          padding: { xs: 1, sm: 2 },
          paddingBottom: { xs: 0.5, sm: 1 },
        }}
      />

      {/* Hero Image Skeleton */}
      <Skeleton variant="rectangular" width="100%" height={250} />

      {/* Main Content Skeleton */}
      <CardContent
        sx={{
          padding: { xs: 1, sm: 2 },
          paddingTop: { xs: 1, sm: 2 },
        }}
      >
        {/* Description Skeleton */}
        <Skeleton variant="text" width="90%" height={20} />
        <Skeleton variant="text" width="80%" height={20} sx={{ mb: 3 }} />

        {/* Stats Grid Skeleton */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {[...Array(4)].map((_, index) => (
            <Grid item xs={6} sm={3} key={index}>
              <Skeleton variant="rounded" width="100%" height={100} />
            </Grid>
          ))}
        </Grid>

        {/* Marine Life Skeleton */}
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="text" width="30%" height={24} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="100%" height={60} />
        </Box>

        {/* Recent Comments Skeleton */}
        <Box>
          <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="100%" height={80} />
        </Box>
      </CardContent>

      {/* Action Buttons Skeleton */}
      <CardActions
        disableSpacing
        sx={{
          justifyContent: "center",
          padding: { xs: 1, sm: 2 },
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1, sm: 2 },
        }}
      >
        <Skeleton variant="rounded" width={180} height={48} />
        <Skeleton variant="rounded" width={150} height={48} />
      </CardActions>

      {/* Optional: Skeleton for collapsed section trigger (if needed) */}
      <Box sx={{ p: { xs: 1, sm: 2 }, borderTop: "1px solid rgba(0, 0, 0, 0.1)" }}>
        <Skeleton variant="text" width="100%" height={40} />
      </Box>
    </Card>
  </Container>
);

export default React.memo(DivesiteSkeleton);
